<template>
  <div
    id="icon-pack-about"
    class="icon-pack-about display-flex flex-column flex-content-between"
    style="gap: var(--spacing-2xl); height: 100%"
  >
    <div>
      <div
        class="display-flex flex-items-center"
        style="gap: var(--spacing-sm)"
      >
        <h1
          class="text-uppercase size-md margin-bottom-0"
          style="letter-spacing: var(--letter-spacing-3xl); font-weight: var(--font-weight-black); color: var(--theme-title-color)"
        >
          {{ iconPack().name }}
        </h1>

        <span
          :aria-label="packTagTooltipText"
          data-balloon-pos="up"
        >
          <wa-tag
            is-rounded
            :label="packTagLabel"
            :theme="packTagTheme"
          />
        </span>
      </div>

      <h2 class="margin-top-sm">{{ iconPack().editorial.title }}</h2>
      <p style="line-height: var(--line-height-lg)">
        {{ iconPack().editorial.description }}
      </p>
    </div>

    <pack-actions />
  </div>
</template>

<script>
  import PackActions from './PackActions'

  export default {
    name: 'PackAbout',

    components: {
      PackActions
    },

    inject: ['hasAccessToIconPack', 'iconPack', 'isReleased', 'requiredPlanLevelForAccess'],

    computed: {
      packTagLabel() {
        return !this.isReleased() ? `Coming soon in ${this.requiredPlanLevelForAccess()}` : `${this.requiredPlanLevelForAccess()}`
      },

      packTagTheme() {
        return this.requiredPlanLevelForAccess() === 'Pro+' ? 'teal' : 'yellow'
      },

      packTagTooltipText() {
        return !this.isReleased()
          ? `Will be only available with a ${this.requiredPlanLevelForAccess()} plan!`
          : `Only available with a ${this.requiredPlanLevelForAccess()} plan!`
      }
    }
  }
</script>
